/**
 * Audio Constants
 * 
 * Centralized audio-related constants including sound types and event names
 */

// Sound Types
export const SOUND_TYPES = {
  CLICK: 'click',
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
  COMPLETE: 'complete',
  ACHIEVEMENT: 'achievement',
  CELEBRATION: 'celebration'
};

// Audio Event Names (for first interaction detection)
export const AUDIO_EVENTS = {
  CLICK: 'click',
  TOUCH_START: 'touchstart',
  KEY_DOWN: 'keydown'
};

// Haptic Feedback Types
export const HAPTIC_TYPES = {
  LIGHT: 'light',
  MEDIUM: 'medium',
  HEAVY: 'heavy',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error'
};

// Feedback Display Types (for showFeedback state)
export const FEEDBACK_STATES = {
  CORRECT: 'correct',
  INCORRECT: 'incorrect'
};

